import React from 'react';
import Hero from '../../common/Hero/Hero';
import {useTranslation} from "react-i18next";

import "./RegistartionBackofficeOperator.scss"
import RegistartionBackofficeOperatorForm
  from '../../forms/RegistartionBackofficeOperatorForm/RegistartionBackofficeOperatorForm';

const RegistartionBackofficeOperatorPage: React.FC = () => {

  const {t} = useTranslation();

  return (
    <div className="RegistartioOperatorPage">
      <Hero
        helpText= {t("registerOperator.helpText")}
        backTo={'/'}
        backToText={t("common.back.home")}
        title={t("registerOperator.header")}
        description={(
          <div>
            <br/>
            {t("registerOperator.title")}
            <br/>
          </div>
        )}/>
      <RegistartionBackofficeOperatorForm/>
    </div>
  )
}

RegistartionBackofficeOperatorPage.propTypes = {};

export default RegistartionBackofficeOperatorPage;
